import { ITitleSubtitleConfigData } from '.';

export const titleSubTitleConfig: ITitleSubtitleConfigData = {
  config1: {
    titleFontStyle: 'headline2',
    subtitleFontStyle: 'headline4',
    configName: 'config1'
  },
  config2: {
    titleFontStyle: 'overline',
    subtitleFontStyle: 'headline4',
    configName: 'config2'
  },
  config3: {
    titleFontStyle: 'mobile-overline',
    subtitleFontStyle: 'headline3',
    configName: 'config3'
  },
  config4: {
    titleFontStyle: 'headline6',
    subtitleFontStyle: 'headline3',
    configName: 'config4'
  },
  config5: {
    titleFontStyle: 'headline6',
    subtitleFontStyle: 'headline6',
    configName: 'config5'
  },
  config6: {
    titleFontStyle: 'overline',
    subtitleFontStyle: 'headline2',
    configName: 'config6'
  },
  config7: {
    titleFontStyle: 'overline',
    subtitleFontStyle: 'headline3',
    configName: 'config7'
  },
  config8: {
    titleFontStyle: 'overline',
    subtitleFontStyle: 'subhead1',
    configName: 'config8'
  }
};
